/* src/components/score-signal-badge/score-signal-badge.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=score-signal-badge.component-BGWCL7RH.css.map */
